import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import AboutCards from "../ui/aboutcards";
import { motion as m, useAnimation, useInView } from "framer-motion";
import { about_items } from "../constants";
import PageFrames from "../ui/pageframes";

const About = () => {
  const cards = useRef(null);
  const cardsInView = useInView(cards, { once: true });
  const cardControls = useAnimation();
  // const message = useRef(null);
  // const messageInView = useInView(message, { once: true });
  // const messageControls = useAnimation();

  useEffect(() => {
    if (cardsInView) {
      cardControls.start("visible");
    }
    // if (messageInView) {
    //   messageControls.start("visible");
    // }
  }, [cardsInView]);

  return (
    <PageFrames id="about">
      {/* About Card section */}
      <m.div
        ref={cards}
        className="flex flex-col w-full items-center"
        variants={{
          hidden: { opacity: 0, y: -20 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={cardControls}
        transition={{ duration: 1 }}
      >
        <div className="flex flex-col md:flex-row items-center md:gap-4 text-[31px] text-center px-4">
          <Icon icon="ep:info-filled" className="text-[#002F6C]" />
          <h1>About Our Company</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full xl:max-w-[80%] p-4 lg:p-8 gap-6">
          {about_items.map((item, index) => (
            <AboutCards
              key={index}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </m.div>

      {/* Director section */}
      {/* <m.div
        className="flex w-full bg-gradient-to-r from-[#FFFFFF] to-[#F2F2F2] p-4 lg:p-8 justify-center"
        ref={message}
        variants={{
          hidden: { opacity: 0, y: -20 },
          visible: { opacity: 1, y: 0 },
        }}
        initial="hidden"
        animate={messageControls}
        transition={{ duration: 1 }}
      >
        <div className="max-w-5xl w-full flex flex-col lg:flex-row items-center gap-10">
          <m.img
            src="director.jpg"
            alt="Director"
            className="w-48 h-48 rounded-full object-cover shadow-lg"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          />

          <m.div
            className="flex flex-col items-center lg:items-start text-center lg:text-left"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <p className="text-xl lg:text-2xl font-serif italic text-gray-800 leading-relaxed">
              “At JKM, we believe in delivering quality and excellence to our
              customers. Our mission is to innovate and lead in the ICT sector
              while staying true to our values.”
            </p>
            <p className="mt-4 signature">— , Director</p>
          </m.div>
        </div>
      </m.div> */}
    </PageFrames>
  );
};

export default About;
